import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    announcements: [],
    recipients: [],
    announcement: {},
    announcementDeleted: {},
    paginator: [],
    exportRoute: '',
    loading: false,
    errorMsg: '',
    errors: {}
};

const announcementSlice = createSlice({
    name: 'announcements',
    initialState,
    reducers: {
        setAnnouncements: (state, action) => {
            state.announcements = action.payload;
        },
        setAnnouncementRecipients: (state, action) => {
            state.recipients = action.payload;
        },
        setAnnouncement: (state, action) => {
            state.announcement = action.payload;
        },
        setAnnouncementDeleted: (state, action) => {
            state.announcementDeleted = action.payload;
        },
        setPaginator: (state, action) => {
            state.paginator = action.payload;
        },
        setExportRoute: (state, action) => {
            state.exportRoute = action.payload;
        },
        getErrors: (state, action) => {
            state.errorMsg = action.payload.errorMsg;
            state.errors = action.payload.errors;
        },
        clearErrors: (state) => {
            state.errorMsg = '';
            state.errors = '';
        },
        loading: (state, action) => {
            state.loading = action.payload;
        }
    },
});

export const { loading, setAnnouncements, setAnnouncementRecipients, setAnnouncement, setAnnouncementDeleted, setPaginator, setExportRoute, clearErrors, getErrors } = announcementSlice.actions;
export default announcementSlice.reducer;
